// src/services/permisosService.js
import api from "./Api"; // 👈 Respeta la A mayúscula del archivo

// Base relativa al baseURL de Api.js (funciona en dev/prod)
const BASE = "/Permisos";

/**
 * Obtiene funciones/bitset por email.
 * Backend: GET /api/permisos/funciones-activas-por-email?email=...
 * Devuelve: { tipo, bitset, funciones, esSuperAdmin }
 */
export async function funcionesActivasPorEmail(email, token) {
  try {
    const config = { params: { email } };

    // Si llega token explícito (p. ej. justo tras el login), lo agregamos.
    // Si no, el interceptor de Api.js tomará el de localStorage.
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }

    const res = await api.get(`${BASE}/funciones-activas-por-email`, config);
    const data = res?.data ?? {};

    return {
      tipo: data?.tipo ?? null,
      bitset: data?.bitset ?? "",
      funciones: data?.funciones ?? {},
      esSuperAdmin: !!data?.esSuperAdmin,
    };
  } catch (err) {
    const status = err?.response?.status ?? 0;
    const body = err?.response?.data ?? err?.message ?? "";
    const msg =
      typeof body === "string" ? body.slice(0, 300) : JSON.stringify(body).slice(0, 300);
    const e = new Error(`HTTP ${status}: ${msg}`);
    e.status = status;
    e.body = body;
    throw e;
  }
}

// Alias para no romper imports existentes
export const obtenerFuncionesPorEmail = funcionesActivasPorEmail;

// ✅ Evita "import/no-anonymous-default-export"
const permisosService = {
  funcionesActivasPorEmail,
  obtenerFuncionesPorEmail,
};

export default permisosService;
